import { zodResolver } from '@hookform/resolvers/zod'
import { useState } from 'react'
import { useForm } from 'react-hook-form'
import copyAndPaste from 'src/assets/copy-and-paste.svg'
import { showAlertError } from 'src/components/alertError'
import { ModalLoader } from 'src/components/modalLoader'
import type {
  BeneficiaryDataProps,
  NewPixFormProps,
} from 'src/pages/pixOptions/components/NewPix/NewPixForm'
import { api } from 'src/services/api'
import { isAxiosError } from 'src/utils/isAxiosError'
import { setAuthToken } from 'src/utils/setAuthToken'
import { z } from 'zod'

interface PasteStepProps extends NewPixFormProps {
  setBeneficiaryData: React.Dispatch<React.SetStateAction<BeneficiaryDataProps>>
  setStep: React.Dispatch<React.SetStateAction<number>>
  setDecodedEmv: React.Dispatch<React.SetStateAction<any>>
}

const schema = z.object({
  key: z.string().min(1, 'Campo obrigatório'),
})

type PasteStepFormData = z.infer<typeof schema>

export const PasteStep = ({
  nextStep,
  setBeneficiaryData,
  setStep,
  setDecodedEmv,
}: PasteStepProps) => {
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm<PasteStepFormData>({
    resolver: zodResolver(schema),
  })
  const [isSubmiting, setIsSubmiting] = useState(false)

  const onSubmit = async (data: PasteStepFormData) => {
    setIsSubmiting(true)
    try {
      setAuthToken()
      const response = await api.post<{
        type: string
        pix_key: {
          key: string
          type: string
        }
        txid: string
        amount: number
        receiver: {
          name: string
          city: string
          document?: string
        }
        payer_question: string
      }>('/pix/decode', {
        content: data.key,
      })
      setDecodedEmv(response.data)
      setBeneficiaryData({
        name: response?.data?.receiver.name,
        beneficiaryDocument: response?.data?.receiver.document,
        payer_question: response?.data?.payer_question,
        key: response?.data?.pix_key.key,
        amount: response?.data?.amount,
        id: response?.data?.txid,
        emv: data.key,
      })
      // console.log(response)
      nextStep()
    } catch (error) {
      if (isAxiosError(error) && error.response) {
        if (error.response.status === 401) {
          return setStep(5)
        }
        const errorMessage = (error.response.data as { message: string })
          .message
        showAlertError(errorMessage)
      } else {
        showAlertError('Ocorreu um erro inesperado.')
      }
    } finally {
      setIsSubmiting(false)
    }
  }

  if (isSubmiting) {
    return <ModalLoader />
  }

  return (
    <form
      onSubmit={handleSubmit(onSubmit)}
      className="flex flex-col items-center gap-5 px-20 py-12"
    >
      <img src={copyAndPaste} alt="copy-and-paste" />
      <h2 className="text-[30px] font-bold">Pague com Copia e Cola</h2>
      <input
        className="border border-[#163172] rounded-md w-[70%] text-[#404040] py-2 px-4 bg-white"
        placeholder="Digite o código ou cole aqui"
        {...register('key')}
      />
      {errors.key && <span className="text-red-500">{errors.key.message}</span>}

      <button
        type="submit"
        className="bg-[#004A8A] rounded-md text-[15px] w-[70%] font-bold text-white py-2 px-4"
      >
        Confirmar e continuar
      </button>
    </form>
  )
}
